import React, { useContext } from 'react';
import { FormattedMessage, IntlContext } from 'react-intl';
import { useFormikContext, FieldArray, useField } from 'formik';
import AppContext from '../../../components/AppContext';

export default function ClientAccounts(props) {
	
	const { messages } = useContext(IntlContext);
	const appContext = useContext(AppContext);
	
	const { values } = useFormikContext();

	const meta = useField("clientAccounts")[1];

	
	return (
		<div className="form-group col-md-12 text-left magical-incantation">
		  <FieldArray name="clientAccounts"
		    render={(arrayHelpers) => {
		    	props.FieldArrayHelpersRef.current = arrayHelpers;
		    	return (
		    		<>
		    		  <section className="panel panel-default error-parent">
		    		    <header className="panel-heading bold">
		    		      <strong><FormattedMessage id="sima.counsel.client.header.0" values={{strong: (chunks) => <strong>{chunks}</strong>}} /></strong>
		    		      <button type="button" className="glyphicon glyphicon-add" style={{float:"right", border:"0"}} onClick={()=>props.setDisplayPopup(true)}>+</button>
		    		    </header>
		    		    <div className="panel-body">
		    		      {values.clientAccounts.length !== 0 ?
		    		      	<div id="wb-auto-4_wrapper" className="dataTables_wrapper no-footer">
		    		      	  <table id="wb-auto-4" className="wb-tables table table-striped table-hover wb-init wb-tables-inited dataTable no-footer" data-wb-tables='{ "columnDefs" : [{"orderable" : false, "targets" : [2, 6, 7]}], "order" : [[1, "asc"]], "lengthMenu" : [[5, 50, 100, -1], [5, 50, 100, "All"]], "pageLength" : -1}' aria-describedby="wb-auto-4_info" aria-label="This table provides a sorting feature via the buttons across the column header row with only one instance visible at a time." >
		    		      	    <thead>
		    		      	      <tr>
		    		      	        <th scope="col" className="sorting"><FormattedMessage id="sima.account.accountInfo.companyLegalName.label"/></th>
		    		      	        <th scope="col" className="sorting"><FormattedMessage id="sima.counsel.client.header.2"/></th>
		    		      	        <th scope="col" className="sorting"><FormattedMessage id="sima.role"/></th>
		    		      	        <th style={{width: "20px"}}></th>
		    		      	      </tr>
		    		      	    </thead>
		    		      	    <tbody>
		    		      	        {values["clientAccounts"].map((clientAccount, index) => {
		    		      	        	const partyTypeLabel = appContext.codeTableLookup?.roles?.[clientAccount.ace_partytype] ?? clientAccount.ace_partytype;
		    		      	        	
		    		      	        	// Is it okay to have 2 return statements??
		    		      	        	return (
		    		      	        		<tr key={"clientAccounts-"+index}>
		    		      	        		  <td>{clientAccount.Name}</td>
		    		      	        		  <td>{clientAccount.ace_businessnumber}</td>
		    		      	        		  <td>{partyTypeLabel}</td>
		    		      	        		  <td><button type="button" className="glyphicon glyphicon-remove close-button" title={messages['button.delete']} style={{float:"right", border:"0"}} onClick={() => arrayHelpers.remove(index)}/></td>
		    		      	        		</tr>
		    		      	        	)
		    		      	        })}
		    		      	    </tbody>
		    		      	  </table>
		    		      	</div>
		    		      :
		    		      	<FormattedMessage id="common.noneSelected"/>
		    		      }
		    		    </div>
		    		  </section>
					  <div id="clientAccounts" >
						  {meta && meta.touched && meta.error ? 
						  <strong className="error" >
							<span className="label label-danger" >
								<span className="prefix">
									<FormattedMessage id="globalAlert.error"/>
									<FormattedMessage id="wet.colon"/> 
								</span> {meta.error}
							</span>
						  </strong>
						  : null
						  }
					  </div>
		    		  <br />
		    		  <div className="form-group col-md-12">
		    		    <p><FormattedMessage id="sima.account.accountInfo.clientCertify.disclaimer" values={{strong: (chunks) => <strong>{chunks}</strong>}} /></p>
		    		    <section>
		    		      <details>
		    		        <summary>
		    		          <h4><FormattedMessage id="sima.representative.add.client.example.2" values={{p: (chunks) => <p>{chunks}</p>, strong: (chunks) => <strong>{chunks}</strong>}} /></h4>
		    		        </summary>
		    		        <div>
		    		          <FormattedMessage id="sima.representative.add.client.example.3" values={{p: (chunks) => <p>{chunks}</p>}} />
		    		        </div>
		    		      </details>
		    		      <details>
		    		        <summary>
		    		          <h4><FormattedMessage id="sima.representative.add.client.example.4" values={{p: (chunks) => <p>{chunks}</p>, strong: (chunks) => <strong>{chunks}</strong>}} /></h4>
		    		        </summary>
		    		        <div>
		    		          <FormattedMessage id="sima.representative.add.client.example.5" values={{p: (chunks) => <p>{chunks}</p>}} />
		    		        </div>
		    		      </details>
		    		    </section>
		    		  </div>
		    		</>
		    	);
		    }}
		  />
		</div>
	);
}


